import React,{useMemo,useState} from 'react';
import {pcCategoryStats} from '../utils/pcAnalytics';
import {ResultText} from './ResultText';
export function PC28StatsPage({history,mode}) {
  const [periods,setPeriods]=useState(60);
  const opened=mode==='opened';
  const sample=useMemo(()=>opened?history:history.slice(0,periods),[history,opened,periods]);
  const sections=useMemo(()=>pcCategoryStats(sample),[sample]);
  const label=opened?'已开：':'未开：';
  const count=row=>sample.length?`${opened?row.count:row.missing}期`:'—';
  const rate=row=>sample.length?`${(row.rate*100).toFixed(2)}%`:'—';
  return <div className="pc-stat-cards">
    {!opened&&<div className="pc-filter-tabs" role="group" aria-label="遗漏统计期数">{[20,30,50,60].map(value=><button key={value} type="button" aria-pressed={periods===value} onClick={()=>setPeriods(value)}>最近{value}期</button>)}</div>}
    <p className="pc-sample-note">{opened?'各类次数 ÷ 实际统计期数；特殊形态互斥，极值仅包含两端区间。':'本期开出记0；选定样本内未出现则显示样本期数，真实遗漏可能更长。'} 边类：0–9小边、10–17中、18–27大边。</p>
    <div className="pc-omission-categories">{sections.slice(0,6).map(section=><section className="pc-omission-card" key={section.title}>
      <h3>{section.title}<small>{label}</small></h3>
      <dl>{section.rows.map(row=><div key={row.label}><dt><ResultText value={row.label}/></dt><dd><strong>{count(row)}</strong>{opened&&<small className="pc-stat-rate">{rate(row)}</small>}</dd></div>)}</dl>
    </section>)}</div>
    <section className="pc-stat-section"><h3 className="pc-section-title">和值（00–27）</h3><div className="pc-omission-sums">{sections[6].rows.map(row=><article className="pc-omission-sum-card" key={row.label} aria-label={`和值${row.label}`}>
      <h4>{row.label}</h4><p><span>{label}</span><strong>{count(row)}</strong></p>{opened&&<small className="pc-stat-rate">{rate(row)}</small>}
    </article>)}</div></section>
  </div>;
}
